import { gql } from '@src/lib/gql'

export const UPSERT_USER_EXPERIENCE = gql`
  mutation AdvisorApplyUpsertUserExperience($input: UpsertUserExperienceInput!) {
    upsertUserExperience(input: $input) {
      userExperience {
        id
        userExperienceId
        experienceTypeKey
        organizationName
        positionDescription
        positionTitle
      }
    }
  }
`
